package com.cs.ejobin.navigation

sealed class Screen {
    data object Login : Screen()
    data object Signup : Screen()

    data object ForgotPasswordEmail : Screen()
    data object ForgotPasswordOtp : Screen()
    data object ResetPassword : Screen()

    data object Home : Screen()
    data object CheckoutSuccess : Screen()
    data object CheckoutCancel : Screen()
    data class ExtraDetail(val extraId: String) : Screen()
    data object Profile : Screen()

    data class Paywall(val source: Source) : Screen() {
        enum class Source { AfterSignup, FromProfile, GatedContent }
    }
}